'use strict';

import { newModalFromSelector, newModalWithOptions } from '../components/modal';
import Customer from '../account/customer';
import { init as initPostalCodeValidation } from './postalCodeValidation';
import ExpressCheckoutHelpers from '../checkout/expressCheckout';
import Payment from '../account/payment';
import DispoHelpers from './dispoHelpers';
import Gift from '../checkout/gift';
import BopisHelpers from './bopisHelpers';

var addressHelpers = require('./address');
var shippingHelpers = require('./shipping');
var giftingHelpers = require('checkout/gifting');
var billingHelpers = require('./billing');
var summaryHelpers = require('checkout/summary');
var formHelpers = require('./formErrors');
var gestpayHelper = require('checkout/gestpayHelper');

function addBlockingMessage () {
    var msg = document.getElementById('paymentMsg').innerHTML.trim();
    var $veil = $('<div class="loader"><div class="underlay"></div></div>');
    $veil.append(`<div class="msg">
        <span>${msg}</span>
        <div class="spinner"><span></span></div>
    </div>`);

    $('body').append($veil);
    $veil.find('.spinner-mfra').css('position', 'fixed');
    $veil.click(function (e) {
        e.stopPropagation();
    });
}

function removeBlockingMessage () {
    var $veil = $('.loader');
    if ($veil.parent().hasClass('veiled')) {
        $veil.parent().css('position', '').removeClass('veiled');
    }
    $veil.off('click');
    $veil.remove();
}

function showPaymentErrorMessage (msg) {
    $('.error-message.payment')
        .show()
        .find('.error-message-text')
        .text(msg);
    $('html, body').animate({
        scrollTop: $('.error-message.payment').offset().top - 150
    }, 500);
}

function openPaypalInsufficentMoneyFlow (link) {
    window.location.href = link;
}

// When is ScalaPay multipayment and user return on previous steps (from step 4), clear gift card basket
function checkScalapayMultipayment () {
    var isScalapayMultipayment = $('#checkout-main').data('scalapay-multipayment');
    if (!isScalapayMultipayment) {
        return;
    }
    $('.giftCardDrawer #giftCardContainer').trigger('change');
}

// Cancel recurrent status on specific triggers
function cancelRecurrentStatus () {
    if ($('#checkout-main').data('hasBillingAgreement') === false) {
        return;
    }

    var url = $('#checkout-main').data('cancelRecurrentFlowUrl');
    if (!url) {
        return;
    }

    $.spinner().start();
    $.ajax(url)
        .done(data => {
            if (!data.error) {
                // Cancel recurrent status for PayPal
                if ($('#PayPal[type="radio"]').is(':checked')) {
                    $('.paypal-use-saved-method-checkbox').trigger('click');
                    $('.paypal-content .final-step-button').show();
                }
                // Cancel recurrent status for Portmone
                if ($('#PORTMONE[type="radio"]').is(':checked')) {
                    $('#usePortmoneToken').val('false').attr('value', 'false');
                    $('#savePortmoneToken').val('true').attr('value', 'true');
                }

                $('#checkout-main').attr('data-has-billing-agreement', false).data('hasBillingAgreement', false);
            } else {
                console.error('Error while cancelling recurrent status.');
            }
        })
        .fail(() => {
            console.error('Error during the controller invoke.');
        })
        .always(() => {
            $.spinner().stop();
        });
}

function scrollToTargetConsideringHeader (targetElement) {
    const headerOffset = 70;
    const elementPosition = targetElement.getBoundingClientRect().top;
    const elementPositionWithOffset = elementPosition - headerOffset;
    window.scrollTo({
        top: elementPositionWithOffset,
        behavior: 'smooth'
    });
}

function adjustTooltipPosition () {
    var $tooltip = $('.js-checkoutLongDistance-tooltip');
    var $overflownPositionElement = $('.js-longDistance-text');
    var $expressOverflownPositionElement = $('.js-long-distance-cost-label');
    var $icon = $('.js-longDistance-icon');

    if (!$tooltip.length) return;

    if (!Foundation.MediaQuery.atLeast('medium')) {
        const rect = $tooltip[0].getBoundingClientRect();
        const padding = 8;
        const viewportWidth = window.innerWidth;
        const overflowsLeft = rect.left < padding;
        const overflowsRight = rect.right > viewportWidth - padding;

        if (overflowsLeft || overflowsRight) {
            $tooltip.addClass('cc-tooltip-overflown');
            $expressOverflownPositionElement.addClass('cc-tooltip-overflown-position');
            $overflownPositionElement.addClass('cc-tooltip-overflown-position');
            $icon.css('position', 'unset');
        }
    }
}

function checkoutLongDistanceTooltip () {
    var $overflownPositionElement = $('.js-longDistance-text');
    var $expressOverflownPositionElement = $('.js-long-distance-cost-label');
    var $tooltip = $('.js-checkoutLongDistance-tooltip');
    var $closeBtn = $('.js-checkoutLongDistance-tooltip-close');
    var $infoIcon = $('.js-longDistance-icon');

    function openTooltip ($trigger, $tooltip) {
        $tooltip.addClass('active').attr('aria-hidden', 'false');
        $trigger.attr('aria-expanded', 'true');
        adjustTooltipPosition();
    }

    function closeTooltip ($trigger, $tooltip) {
        $tooltip.removeClass('active').attr('aria-hidden', 'true');
        $trigger.attr('aria-expanded', 'false');

        const fallbackTimeout = setTimeout(() => {
            $tooltip.removeClass('cc-tooltip-overflown');
            $overflownPositionElement.removeClass('cc-tooltip-overflown-position');
            $expressOverflownPositionElement.removeClass('cc-tooltip-overflown-position');
            $trigger.css('position', 'relative');
        }, 300);
        $tooltip.one('transitionend', function () {
            clearTimeout(fallbackTimeout);
            $tooltip.removeClass('cc-tooltip-overflown');
            $overflownPositionElement.removeClass('cc-tooltip-overflown-position');
            $expressOverflownPositionElement.removeClass('cc-tooltip-overflown-position');
            $trigger.css('position', 'relative');
        });
    }

    if (Foundation.MediaQuery.atLeast('large')) {
        // Desktop hover & focus
        $infoIcon.off('mouseenter focusin').on('mouseenter focusin', function () {
            var $trigger = $(this);
            var $tooltip = $trigger.find('.js-checkoutLongDistance-tooltip');
            openTooltip($trigger, $tooltip);
        });

        $infoIcon.off('mouseleave focusout').on('mouseleave focusout', function () {
            var $trigger = $(this);
            var $tooltip = $trigger.find('.js-checkoutLongDistance-tooltip');
            closeTooltip($trigger, $tooltip);
        });
        $('body').off('touchstart.tooltipClose');
    } else {
        // Mobile / touch
        $infoIcon.off('touchstart').on('touchstart', function (e) {
            e.stopPropagation();
            var $trigger = $(this);
            var $tooltip = $trigger.find('.js-checkoutLongDistance-tooltip');

            if ($tooltip.hasClass('active')) {
                closeTooltip($trigger, $tooltip);
            } else {
                openTooltip($trigger, $tooltip);
            }
        });
        $closeBtn.off('click touchstart').on('click touchstart', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var $trigger = $(this).closest('.js-longDistance-icon');
            var $tooltip = $('#longDistanceTooltip');
            closeTooltip($trigger, $tooltip);
        });
        $tooltip.off('touchstart').on('touchstart', function (e) {
            e.stopPropagation();
        });
        $('body').off('touchstart.tooltipClose').on('touchstart.tooltipClose', function (e) {
            $('.js-longDistance-icon').each(function () {
                var $trigger = $(this);
                var $tooltip = $trigger.find('.js-checkoutLongDistance-tooltip');
                if ($tooltip.hasClass('active') &&
                    !$(e.target).closest('.js-checkoutLongDistance-tooltip').length &&
                    !$(e.target).closest('.js-longDistance-icon').length) {
                    closeTooltip($trigger, $tooltip);
                }
            });
        });
    }

    // Keyboard accessibility (Enter / Space)
    if (Foundation.MediaQuery.atLeast('large')) {
        $infoIcon.off('keydown').on('keydown', function (e) {
            var $trigger = $(this);
            var $tooltip = $trigger.find('.js-checkoutLongDistance-tooltip');

            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                if ($tooltip.hasClass('active')) {
                    closeTooltip($trigger, $tooltip);
                    $tooltip.removeClass('cc-tooltipShow');
                    $trigger.off('focusout.longDistanceTooltip');
                } else {
                    openTooltip($trigger, $tooltip);
                    $tooltip.addClass('cc-tooltipShow');
                    // Close tooltip when focus leaves trigger/tooltip
                    $trigger.off('focusout.longDistanceTooltip').on('focusout.longDistanceTooltip', function (ev) {
                        var related = ev.relatedTarget || document.activeElement;
                        if (!$(related).closest('.js-longDistance-icon, .js-checkoutLongDistance-tooltip').length) {
                            closeTooltip($trigger, $tooltip);
                            $tooltip.removeClass('cc-tooltipShow');
                            $trigger.off('focusout.longDistanceTooltip');
                        }
                    });
                }
            } else if (e.key === 'Tab') {
                // Close tooltip and remove focus if user navigates away with Tab
                if ($tooltip.hasClass('active')) {
                    closeTooltip($trigger, $tooltip);
                    $tooltip.removeClass('cc-tooltipShow');
                    $trigger.off('focusout.longDistanceTooltip');
                }
            } else if (e.key === 'Escape') {
                // Close tooltip on Escape without losing the focus
                if ($tooltip.hasClass('active')) {
                    closeTooltip($trigger, $tooltip);
                    $tooltip.removeClass('cc-tooltipShow');
                }
            }
        });
    }
}

window.Parsley.addValidator('nifportugal', {
    validateString: function (value) {
        if (value.length == 9) {
            let tot = 0, control = 0;
            for (let i = 2; i <= 9; i++) {
                tot += value[9 - i] * i;
            }
            let mod = tot % 11;
            if (mod == 0 || mod == 1) { control = 0; } else { control = 11 - mod; }
            return control == value[8];
        };
    }
});

function showCheckoutExitModal () {
    var modal = newModalFromSelector('checkoutExitModal', false, ['checkout-exit-modal']);
    if (modal) {
        $(modal.modalBox).addClass('checkout-exit-modal');
        $(modal.modal).on('click', '.js-checkout-exit-modal-close', function () {
            modal.close();
        });
        modal.open();
    }
}

/**
 * Create the jQuery Checkout Plugin.
 *
 * This jQuery plugin will be registered on the dom element in checkout.isml
 * with the id of 'checkout-main'.
 *
 * The checkout plugin will handle the different state the user interface is in
 * as the user progresses through the varying forms such as shipping and
 * payment.
 *
 * Billing info and payment info are used a bit synonymously in this code.
 *
 */
(function ($) {
    $.fn.checkout = function() { // eslint-disable-line
        var plugin = this;
        var isGestPayIframeMode = $(this).data('gestpayIframemode');
        var gestpayEncryptUrl = $(this).data('gestpayUrl');
        BopisHelpers.clickOnAccordion();
        //
        // Collect form data from user input
        //
        var formData = {
            // Shipping Address
            shipping: {},

            // Billing Address
            billing: {},

            // Payment
            payment: {},

            // Gift Codes
            giftCode: {}
        };

        //
        // The different states/stages of checkout
        //
        var checkoutStages = [
            'shipping',
            'gift',
            'payment',
            'confirm-order'
        ];

        // Check if is Apple Pay enabled device
        if (!window.ApplePaySession || !window.ApplePaySession.canMakePayments() || $('#apple-pay-btn').length < 1) {
            $('.js-apple-pay-container').remove();
        } else {
            $('.js-apple-pay-container').show();
            $('body').on('click', '#apple-pay-btn', function () {
                $('body').trigger('analytics:applepay');
                localStorage.setItem('selectedPaymentMethod', 'DW_APPLE_PAY');
            });
            if ($('.fake-applepay-tab-header').length) {
                $('#apple-pay-btn').remove();
            }
        }

        /**
         * Updates the URL to determine stage
         * @param {number} currentStage - The current stage the user is currently on in the checkout
         */
        function updateUrl (currentStage) {
            history.pushState(
                checkoutStages[currentStage],
                document.title,
                location.pathname
                + '?stage='
                + checkoutStages[currentStage]
                + '#'
                + checkoutStages[currentStage]
            );
        }

        //
        // Local member methods of the Checkout plugin
        //
        var members = {

            // initialize the currentStage variable for the first time
            currentStage: 0,

            isPartialStage: false,

            /**
             * Set or update the checkout stage (AKA the shipping, billing, payment, etc... steps)
             * @returns {Object} a promise
             */
            updateStage: function () {
                var stage = checkoutStages[members.currentStage];
                var defer = $.Deferred(); // eslint-disable-line

                $('.success-message.giftkit').hide();

                if (stage === 'shipping') {
                    var isBopisActive = $('.store-info').hasClass('is-bopis');
                    var isPersonalizedBasket = $('.personalization-item').length > 0;
                    var isAllMainShipment = $('#isAllMainShipment').val() === 'true';
                    var selectedShippingMethod = $('.shipping-form .shipping-method-selected');
                    var isShippingSelectedBopis = selectedShippingMethod.hasClass('js-is-bopis');
                    var shippingMethodType = 'courier';
                    if (selectedShippingMethod.attr('data-pickup') === 'true') {
                        shippingMethodType = 'store';
                    } else if (selectedShippingMethod.attr('data-pickup-point') === 'true') {
                        shippingMethodType = 'pickup';
                    }
                    var isShippingMethodValid = BopisHelpers.validateShippingMethod(isShippingSelectedBopis ? 'bopis' : shippingMethodType);
                    if (!isShippingMethodValid) return;

                    if (isPersonalizedBasket && isBopisActive && !BopisHelpers.isBopisOnlyActive()) {
                        DispoHelpers.selectBopisStore();
                        return;
                    }
                    if (isPersonalizedBasket && !isAllMainShipment && !BopisHelpers.isBopisOnlyActive()) {
                        DispoHelpers.removeNotMainPersonalization();
                        return;
                    }
                    //
                    // Clear Previous Errors
                    //
                    formHelpers.clearPreviousErrors('.shipping-form');
                    var stepShippingCompleted = $('.shipping-form').attr('data-checkout-stage-completed');

                    if (stepShippingCompleted === 'false') {
                        // Submit first step Shipping - check only the shipping method selected
                        var isMultiShip = $('#checkout-main').hasClass('multi-ship');
                        var formSelector = isMultiShip ? '.multi-shipping .active form' : '.single-shipping form';
                        var form = $(formSelector);
                        if (isMultiShip && form.length === 0) {
                            $('.shipping-form').attr('checkout-stage-completed', 'true');
                        } else {
                            $.spinner().start();

                            let shippingFormData = form.serialize();
                            if (shippingFormData.indexOf('isBopis') < 1) {
                                var isBopisActive = $('.shipping-method-selected .store-info:not(.js-select-pickup-recap)').hasClass('is-bopis');
                                shippingFormData += '&isBopis=' + isBopisActive;
                            }
                            if (shippingFormData.indexOf('bopisPickUpLabel') < 1) {
                                var bopisPickUpLabel = $('.shipping-method-selected.js-is-bopis .estimated-delivery')?.text() !== '' ? 
                                                        $('.shipping-method-selected.js-is-bopis .estimated-delivery').text() : 
                                                        document.querySelector('.shipping-method-selected.js-is-bopis input.dispoArrivalInterval')?.value;
                                shippingFormData += '&bopisPickUpLabel=' + bopisPickUpLabel;
                            }
                            $('body').trigger('checkout:serializeShipping', {
                                form: form,
                                data: shippingFormData,
                                callback: function (data) {
                                    shippingFormData = data;
                                }
                            });

                            $.ajax({
                                url: form.attr('data-checkout-select-shipping-url'),
                                type: 'post',
                                data: shippingFormData,
                                success: function (data) {
                                    $.spinner().stop();
                                    if (data.error) {
                                        $('.error-message.generic')
                                            .show()
                                            .find('.error-message-text')
                                            .text(data.errorMessage);
                                        $('.error-message.generic')[0].scrollIntoView();
                                        defer.reject();
                                    } else {
                                        shippingHelpers.methods.shippingSelectionResponse(data);
                                        if ($('.next-step-button.shipping.shipping-pt') && $('.next-step-button.shipping.shipping-pt').length > 0) {
                                            $('.next-step-button.shipping.shipping-pt').addClass('hide');
                                        }
                                        defer.resolve();
                                    }
                                },
                                error: function (err) {
                                    $.spinner().stop();
                                    if (err.responseJSON.redirectUrl) {
                                        window.location.href = err.responseJSON.redirectUrl;
                                    }
                                    // Server error submitting form
                                    defer.reject(err.responseJSON);
                                }
                            });
                        }
                        return defer;
                    }
                    let currentCountryShipping = $('.currentCountryShipping').val();
                    if (currentCountryShipping && $('select.shippingCountry').val() !== currentCountryShipping) {
                        $('select.shippingCountry').val(currentCountryShipping).trigger('chosen:updated');
                    }
                    if ($('label[for="billInDifferentAddress"]').hasClass('hide')) {
                        if ($('.billingFormGroup').length > 0 && $('.billingFormGroup').hasClass('hide')) {
                            $('label[for="billInDifferentAddress"] input').prop('checked', true);
                            $('label[for="billInDifferentAddress"] input').val(1);
                            $('.billingFormGroup').removeClass('hide');
                            if (!$('.billingAddressPrefilled').length) {
                                var shippingForm = $('form[name=dwfrm_shipping]');
                                var shippingData = {
                                    firstName: $('input[name$=_firstName]', shippingForm).val(),
                                    lastName: $('input[name$=_lastName]', shippingForm).val(),
                                    address1: $('input[name$=_address1]', shippingForm).val(),
                                    address2: $('input[name$=_address2]', shippingForm).val(),
                                    city: $('input[name$=_city]', shippingForm).val(),
                                    postalCode: $('input[name$=_postalCode]', shippingForm).val(),
                                    stateCode: $('select[name$=_stateCode],input[name$=_stateCode]', shippingForm).val(),
                                    countryCode: $('select[name$=_country]', shippingForm).val()
                                };
                                $('input[name$=_billing_addressFields_firstName]').val(shippingData.firstName);
                                $('input[name$=_billing_addressFields_lastName]').val(shippingData.lastName);
                                $('input[name$=_billing_addressFields_address1]').val(shippingData.address1);
                                $('input[name$=_billing_addressFields_address2]').val(shippingData.address2);
                                $('input[name$=_billing_addressFields_city]').val(shippingData.city);
                                $('input[name$=_billing_addressFields_postalCode]').val(shippingData.postalCode);
                                $('select[name$=_billing_addressFields_states_stateCode],input[name$=_billing_addressFields_stateCode]')
                                    .val(shippingData.stateCode)
                                    .trigger('chosen:updated');
                                $('select[name$=_billing_addressFields_country]').val(shippingData.countryCode).trigger('chosen:updated');
                            }
                            return;
                        }
                    }

                    if (/^([0])\1{5,}$/.test($('#billingSdi').val())) {
                        $('#billingPecEmailAddress').attr('required', true);
                    }

                    if ($('.addressSelector input[type="radio"]:checked').length > 0) {
                        $('select.shippingState').val($('.addressSelector input[type="radio"]:checked').attr('data-state-code')).trigger('chosen:updated');
                    }

                    // Phone numer optional with Express Flow
                    if ($('.data-checkout-stage').attr('data-phone-optional') === 'true') {
                        $('.shippingPhoneNumber').attr('required', false);
                    }

                    var $shippingForm = $('.shipping-form');
                    if ($('#billingIsAvailable').val() === '0') {
                        // When a select tag with an id 'shippingState' has a chosen.js tag that is not hidden.
                        let shippingState = $('#shippingState_chosen:not(#shippingState_chosen:hidden)').length ? '#shippingState:hidden' : '';

                        if (!$shippingForm.parsley({excluded: '#billingIsAvailable,.billingFormGroup input,:hidden'}).validate()) {
                            // accesibility: scroll and focus the first invalid input
                            let $firstError = $shippingForm.find('input.is-invalid-input:visible').first();
                            if ($firstError.length) {
                                $('html, body').animate({scrollTop: $firstError.offset().top - 120}, 500, function () {
                                    $firstError.trigger('focus');
                                });
                            }

                            return;
                        }
                    } else {
                        // When a select tag with an id 'shippingState' has a chosen.js tag that is not hidden.
                        let shippingState = $('#shippingState_chosen:not(#shippingState_chosen:hidden)').length ? '#shippingState:hidden' : '';

                        // When a select tag with an id 'billingState' has a  chosen.js field that is not hidden.
                        let billingState = $('#billingState_chosen:not(#billingState_chosen:hidden)').length ? '#billingState:hidden' : '';

                        if (!$shippingForm.parsley({excluded: ':hidden'}).validate()) {
                            // accesibility: scroll and focus the first invalid input
                            let $firstError = $shippingForm.find('input.is-invalid-input:visible').first();
                            $('html, body').animate({scrollTop: $firstError.offset().top - 120}, 500, function () {
                                $firstError.trigger('focus');
                            });

                            return;
                        }
                    }

                    // For Ukraine: check only on street field (city is already filled and checked on click)
                    var streetInput = $('.getNovaPoshtaStreet');
                    if (streetInput.length > 0
                        && streetInput.val().length > 0
                        && $('input[id^="shippingMethod"][data-pickup="false"][data-pickup-point="false"]').is(':checked')
                        && $('#shippingAddressStreetRefCode').val().length === 0) {
                        $('body').trigger('novaPoshta:invalidShippingValue', streetInput);
                        return;
                    }

                    //
                    // Submit the Shipiing Address Form
                    //
                    var isMultiShip = $('#checkout-main').hasClass('multi-ship');
                    var formSelector = isMultiShip ? '.multi-shipping .active form' : '.single-shipping form';
                    var form = $(formSelector);

                    if (isMultiShip && form.length === 0) {
                        // in case the multi ship form is already submitted
                        var url = $('#checkout-main').attr('data-checkout-get-url');
                        $.ajax({
                            url: url,
                            method: 'GET',
                            success: function (data) {
                                $('body').trigger('checkout:updateCheckoutView', {
                                    order: data.order,
                                    customer: data.customer
                                });
                                defer.resolve();
                            },
                            error: function () {
                                // Server error submitting form
                                defer.reject();
                            }
                        });
                    } else {
                        $.spinner().start();

                        let shippingFormData = form.serialize();
                        // billingIsAvailable, when active, is passed as '1'. In case it is not, it has to be set to '0' manually. Otherwise, in shippingFormData, it is not present.
                        if (shippingFormData.indexOf('dwfrm_billing_billingIsAvailable') < 1) {
                            shippingFormData += '&dwfrm_billing_billingIsAvailable=0';
                        }
                        // billInDifferentAddress, when active, is passed as '1'. In case it is not, it has to be set to '0' manually. Otherwise, in shippingFormData, it is not present.
                        if (shippingFormData.indexOf('dwfrm_billing_billInDifferentAddress') < 1) {
                            shippingFormData += '&dwfrm_billing_billInDifferentAddress=0';
                        }
                        // in case of unhappy flow it's necessary to valorize the shippingMethodID
                        if (shippingFormData.indexOf('dwfrm_shipping_shippingAddress_shippingMethodID') < 1) {
                            let shippingMethodID = $('.shipping-method-block input[name=dwfrm_shipping_shippingAddress_shippingMethodID]:checked').attr('value');
                            shippingFormData += '&dwfrm_shipping_shippingAddress_shippingMethodID=' + shippingMethodID;
                        }

                        if (shippingFormData.indexOf('isBopis') < 1) {
                            isBopisActive = $('.shipping-method-selected.js-is-bopis').length > 0;
                            var dispoArrival = $('.js-store-dispo-info-collection').val();
                            shippingFormData += '&isBopis=' + isBopisActive;
                            shippingFormData += '&dispoArrival=' + dispoArrival;
                        }

                        if (shippingFormData.indexOf('bopisPickUpLabel') < 1) {
                            var bopisPickUpLabel = $('.shipping-method-selected.js-is-bopis .estimated-delivery')?.text() !== '' ? 
                                                    $('.shipping-method-selected.js-is-bopis .estimated-delivery').text() : 
                                                    document.querySelector('.shipping-method-selected.js-is-bopis input.dispoArrivalInterval')?.value;
                            shippingFormData += '&bopisPickUpLabel=' + bopisPickUpLabel;
                        }

                        $('body').trigger('checkout:serializeShipping', {
                            form: form,
                            data: shippingFormData,
                            callback: function (data) {
                                shippingFormData = data;
                            }
                        });

                        /*
                         * Reset parsley form to hide custom messages (e.g. dispo).
                         * Standard parsley errors are managed before the actual submit.
                         */
                        form.parsley().reset();

                        $.ajax({
                            url: form.attr('action'),
                            type: 'post',
                            data: shippingFormData,
                            success: function (data) {
                                $.spinner().stop();
                                $('.js-login-link-container').hide();
                                $('#checkout-main').attr('data-isspliced', data.spliced);
                                shippingHelpers.methods.shippingFormResponse(defer, data);
                                // Check on saved address validation (Avalara)
                                var invalidFields = $('.is-invalid');
                                if (invalidFields.length > 0) {
                                    var addressId = $('#addressId').val() || null;
                                    if (addressId) {
                                        var addressSelectors = $('input[name="addressSelector"][data-address-id="' + addressId + '"]');
                                        if (addressSelectors && addressSelectors.length > 0) {
                                            var internalContainers = addressSelectors.eq(0).parents('.internal-container');
                                            if (internalContainers && internalContainers.length > 0) {
                                                var showDetailsLink = internalContainers.eq(0).find('.js-show-details');
                                                if (showDetailsLink && showDetailsLink.length > 0) {
                                                    showDetailsLink.trigger('click');
                                                    $('html, body').animate({
                                                        scrollTop: invalidFields.eq(0).offset().top - 150
                                                    }, 500, 'linear');
                                                }
                                            }
                                        }
                                    }
                                }
                                if ($('#isDispoCountry').val() !== 'false') {
                                    /**
                                     * Manage "disponibilità allargata" error messages
                                     */
                                    if (data.isDispoError) {
                                        data.dispoErrorFields.forEach(errorField => {
                                            // Force error message through parsley.js
                                            const $dispoErrorFieldInput = $(`[name$="${errorField}"]`, '#shippingAddressForm .shipping-address-block');
                                            $dispoErrorFieldInput.parsley().addError('forcederror', {
                                                message: $dispoErrorFieldInput.data('dispo-error-message'),
                                                updateClass: true
                                            });

                                            // Scroll to error message
                                            const $dispoErrorFormGroup = $dispoErrorFieldInput.closest('.form-group');
                                            $('html, body').animate({
                                                scrollTop: $dispoErrorFormGroup.offset().top - $dispoErrorFormGroup.height()
                                            }, 500);

                                            // Remove error message on next input
                                            $dispoErrorFieldInput.one('input', () => {
                                                $dispoErrorFieldInput.parsley().removeError('forcederror');
                                            });
                                        });

                                        return defer.reject();
                                    }

                                    $('.orderProductWrapper').html(data.orderSummary);
                                    $('.wrapper-gift-container').addClass('hidden');
                                    if (data.isBopis !== 'true' && data.isBopis !== true) {
                                        var wrapperGiftContainer = $('.wrapper-gift-container').html();
                                        $('.copy-wrapper-gift-container').html(wrapperGiftContainer);
                                        Gift.run();
                                    }
                                    DispoHelpers.run();
                                    data.order.totals.longDistanceTotalPrice != null ? $('.long-distance-message').removeClass('hide') : $('.long-distance-message').addClass('hide');
                                    $('.data-checkout-stage').attr('data-express-flow') === 'true' ? $('.js-remove-external-items-modal').addClass('hide') : $('.js-remove-external-items-modal').removeClass('hide');
                                }
                            },
                            error: function (err) {
                                $.spinner().stop();
                                if (err.responseJSON.redirectUrl) {
                                    window.location.href = err.responseJSON.redirectUrl;
                                }
                                // Server error submitting form
                                defer.reject(err.responseJSON);
                            }
                        });
                    }
                    return defer;
                } else if (stage === 'gift') {
                    //
                    // Gift step introduced with Checkout review
                    //
                } else if (stage === 'payment' || stage === 'confirm-order') {
                    //
                    // Submit the Billing Address Form
                    //
                    formHelpers.clearPreviousErrors('.payment-form');

                    const $paymentForm = $('#dwfrm_billing');

                    $paymentForm.on('submit', (e) => {
                        e.preventDefault();
                    });

                    $('#cardType').prop('disabled', false);
                    var paymentForm = $paymentForm.serialize();

                    const countryCodeElement = document.getElementById('country-code');
                    if (countryCodeElement && countryCodeElement.value) {
                        let cc = countryCodeElement.value;
                        if ($('.billingVATNumber').val() && $('.billingVATNumber').val().indexOf(cc) === -1) {
                            let tmpValue = $('.billingVATNumber').val();
                            $('.billingVATNumber').val(cc + tmpValue);
                        }
                    }
                    // phone number optional with Express Checkout
                    if ($('.data-checkout-stage').attr('data-phone-optional') === 'true') {
                        $('#phoneNumber').attr('required', false);
                        $('#phoneNumberAmex').attr('required', false);
                    }

                    if (parseInt($('#billingIsAvailable').val()) === 1) {
                        if (!$('#dwfrm_billing').parsley({
                            excluded: '.drawer:not(.active) #mbwayPrefix,.drawer:not(.active) #mbwayPhoneNumber,#phoneNumber,#cardNumber,#cardNumberAmex,#expirationMonth,#expirationYear,#securityCode,.cardOwner,#billingIsAvailable,[disabled],.drawer:not(.active) input,.no-validate,#streetName,#streetNumber,#securityCodeAmex,#expirationYearAmex,#expirationMonthAmex,.giftCardDrawer .giftcard-submit-payment.hidden input,.policy-promotion-payment.hidden input'
                        }).validate()) {
                            console.warn('Payment form validation failed.');
                            defer.reject();
                            return defer;
                        }
                    } else {
                        if (!$('#dwfrm_billing').parsley({
                            excluded: '.drawer:not(.active) #mbwayPrefix,.drawer:not(.active) #mbwayPhoneNumber,#phoneNumber,#cardNumber,#cardNumberAmex,#expirationMonth,#expirationYear,#securityCode,.cardOwner,#billingIsAvailable,[disabled],.drawer:not(.active) input,.billing-address input,.billing-address select,.no-validate,#streetName,#streetNumber,#securityCodeAmex,#expirationYearAmex,#expirationMonthAmex,.giftCardDrawer .giftcard-submit-payment.hidden input,.policy-promotion-payment.hidden input'
                        }).validate()) {
                            var $tcCheckbox = $('#dwfrm_billing .checkbox-style.is-invalid-input');
                            if ($tcCheckbox.length) {
                                $('html, body').animate({
                                    scrollTop: $tcCheckbox.offset().top - 120
                                }, 500);
                            }
                            console.warn('Payment form validation failed.');
                            defer.reject();
                            return defer;
                        }
                    }

                    $('body').trigger('checkout:serializeBilling', {
                        form: $('#dwfrm_billing'),
                        data: paymentForm,
                        callback: function (data) {
                            paymentForm = data;
                        }
                    });
                    if (!Foundation.MediaQuery.is('medium')) {
                        paymentForm += ('&mobile=true');
                    }

                    if ($('.data-checkout-stage').data('customer-type') === 'registered' && $('.saved-payment-instrument').length > 0) {
                        // if payment method is credit card
                        if ($('input[name$="paymentMethod"]:checked').val() === 'CREDIT_CARD') {
                            if (!members.isNewPayment()) {
                                var $savedPaymentInstrument = $('.saved-payment-instrument' + '.selected-payment');

                                paymentForm += '&storedPaymentUUID=' + $savedPaymentInstrument.data('uuid');
                            }
                        }
                    } else {
                        $('.payment-information').data('is-new-payment', true);
                    }

                    if (isGestPayIframeMode) {
                        paymentForm = paymentForm.replace(/(dwfrm_billing_creditCardFields_cardNumber=)(\d{6})(\d{6})(\d)(\d)(\d)(\d)/i, '$1XXXXXXXXXXXX$4$5$6$7&dwfrm_billing_creditCardFields_binCode=$2');
                        // Remove the security code field from paymentForm and mask the card number
                        if (!gestpayHelper.isSavedCard()) {
                            paymentForm = paymentForm.replace(/(dwfrm_billing_creditCardFields_securityCode=)[^&]*/i, '$1XXX');
                        }
                    }

                    if ($('input#DW_APPLE_PAY:checked').length > 0 && $('#apple-pay-btn').length > 0) {
                        $('.js-apple-pay-container').addClass('isStandardFlow');
                        removeBlockingMessage();
                        $('body').trigger('checkout:afterHandleNextStage', {
                            stage: 3
                        });
                        $('#apple-pay-btn').trigger('click');
                        return;
                    }

                    // Push recurrent status to AJAX call
                    paymentForm += '&recurrentStatus=' + $('#checkout-main').data('hasBillingAgreement');

                    var sendPaymentAjax = {
                        url: $('#dwfrm_billing').attr('action'),
                        method: 'POST',
                        data: paymentForm,
                        success: function (data) {
                            // look for field validation errors
                            if (data.error) {
                                removeBlockingMessage();
                                if (data.cartError) {
                                    window.location.href = data.redirectUrl;
                                    defer.reject();
                                } else if ('fieldErrors' in data && data.fieldErrors.length) {
                                    data.fieldErrors.forEach(function (error) {
                                        if (Object.keys(error).length) {
                                            formHelpers.loadFormErrors('.payment-form', error);
                                        }
                                    });
                                    defer.reject();
                                } else if ('serverErrors' in data && data.serverErrors.length) {
                                    data.serverErrors.forEach(function (error) {
                                        showPaymentErrorMessage(error);
                                    });
                                    defer.reject();
                                } else if (data.errorMessage && data.errorCode === '10486' && data.redirectUrl !== '') {
                                    showPaymentErrorMessage(data.errorMessage);
                                    openPaypalInsufficentMoneyFlow(data.redirectUrl);
                                    defer.reject();
                                } else if (data.errorMessage) {
                                    showPaymentErrorMessage(data.errorMessage);
                                    defer.reject();
                                } else {
                                    // go to appropriate stage and display error message
                                    defer.reject(data);
                                }
                            } else if ('avalaraError' in data && data.avalaraError) {
                                window.location.href = data.redirectUrl;
                                defer.resolve();
                            } else if ('isScalaPayPaymentMethod' in data && data.isScalaPayPaymentMethod) {
                                localStorage.setItem('selectedPaymentMethod', 'ScalaPay');
                                window.location.href = data.redirectURL;
                                defer.resolve();
                            } else if ('isAmazonPay' in data && data.isAmazonPay) {
                                localStorage.setItem('selectedPaymentMethod', 'AMAZONPAY');
                                window.location.href = data.continueUrl;
                                defer.resolve();
                            } else if ('fraudCheckError' in data && data.fraudCheckError) {
                                window.location.href = data.redirectUrl;
                                defer.resolve();
                            } else {
                                $('body').on('checkout:completeKlarna', function () {
                                    $('body').trigger('checkout:afterHandleNextStage', {
                                        stage: 3
                                    });
                                });
                                $('body').trigger('checkout:updateCheckoutView', {
                                    order: data.order,
                                    customer: data.customer,
                                    action: 'payment'
                                });
                                if (isGestPayIframeMode && $('input[name$="paymentMethod"]:checked').val() === 'CREDIT_CARD' && members.isNewPayment()) {
                                    var orderId = data.orderID;
                                    var orderToken = data.orderToken;
                                    var cryptDecryptString = data.cryptDecryptString;
                                    GestPay.CreatePaymentPage(data.shopLogin, cryptDecryptString, function (Result) {
                                        if (Result.ErrorCode == 10) {
                                            GestPay.SendPayment({
                                                CC: members.getCreditCardNumber().data('cleave').getRawValue(),
                                                EXPMM: ('00' + members.getExpirationMonth().val()).slice(-2),
                                                EXPYY: members.getExpirationYear().val().slice(-2),
                                                CVV2: members.getSecurityCode().val(),
                                                Name: $('input[name$=_firstName]', form).val() + ' ' + $('input[name$=_lastName]', form).val(),
                                                Email: members.getCreditCardFieldsEmail().val()
                                            }, function (ResultOfSendPayment) {
                                                ResultOfSendPayment.cryptDecryptString = cryptDecryptString;
                                                ResultOfSendPayment.orderId = orderId;
                                                ResultOfSendPayment.orderToken = orderToken;
                                                $.ajax({
                                                    url: $('.place-order-iframe').data('action'),
                                                    data: ResultOfSendPayment,
                                                    method: 'POST'
                                                }).done(function (resultOfPlaceOrderIFrame) {
                                                    if (resultOfPlaceOrderIFrame.error) {
                                                        removeBlockingMessage();
                                                        if (resultOfPlaceOrderIFrame.cartError) {
                                                            window.location.href = resultOfPlaceOrderIFrame.redirectUrl;
                                                            defer.reject();
                                                        } else {
                                                            // go to appropriate stage and display error message
                                                            defer.reject(resultOfPlaceOrderIFrame);
                                                        }
                                                    } else if (resultOfPlaceOrderIFrame.redirectUrl) {
                                                        $('body').trigger('checkout:afterHandleNextStage', { stage: members.currentStage + 2 });
                                                        window.location.href = resultOfPlaceOrderIFrame.redirectUrl;
                                                    } else {
                                                        $('body').trigger('checkout:afterHandleNextStage', { stage: members.currentStage + 2 });
                                                        var continueUrl = resultOfPlaceOrderIFrame.continueUrl;
                                                        var urlParams = {
                                                            ID: resultOfPlaceOrderIFrame.orderID,
                                                            token: resultOfPlaceOrderIFrame.orderToken
                                                        };
                                                        continueUrl += (continueUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(urlParams).map(function (key) {
                                                            return key + '=' + encodeURIComponent(urlParams[key]);
                                                        }).join('&');

                                                        window.location.href = continueUrl;
                                                    }
                                                }).fail(function () {
                                                    removeBlockingMessage();
                                                });
                                            });
                                        } else {
                                            removeBlockingMessage();
                                            showPaymentErrorMessage($(plugin).data('errormsg-default'));
                                            defer.reject();
                                        }
                                    });
                                } else if (isGestPayIframeMode && $('input[name$="paymentMethod"]:checked').val() === 'CREDIT_CARD' && !members.isNewPayment()) {
                                    // Saved card case
                                    $.ajax({
                                        url: $('.place-order').data('saved-card-action'),
                                        method: 'POST',
                                        data: {
                                            ID: data.orderID,
                                            token: data.orderToken,
                                            continueUrl: data.continueUrl,
                                            is3dsecurecheck: data.is3dsecurecheck
                                        },
                                        success: function (resultOfPlaceOrderSavedCard) {
                                            if (resultOfPlaceOrderSavedCard.error) {
                                                removeBlockingMessage();
                                                showPaymentErrorMessage(resultOfPlaceOrderSavedCard.errorMessage);
                                                defer.reject();
                                            } else {
                                                var continueUrl = resultOfPlaceOrderSavedCard.continueUrl;
                                                var urlParams = {
                                                    ID: resultOfPlaceOrderSavedCard.orderID,
                                                    token: resultOfPlaceOrderSavedCard.orderToken
                                                };

                                                continueUrl += (continueUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(urlParams).map(function (key) {
                                                    return key + '=' + encodeURIComponent(urlParams[key]);
                                                }).join('&');

                                                window.location.href = continueUrl;
                                            }
                                        },
                                        error: function () {
                                            showPaymentErrorMessage($(plugin).data('errormsg-default'));
                                            defer.reject();
                                            removeBlockingMessage();
                                        }
                                    });
                                } else {
                                    // Check if is AsiaPay to load info in AsiaPay form and submit it
                                    if ('asiaPayPreparationResult' in data && data.asiaPayPreparationResult) {
                                        $('#asiaPayFormContainer').html(data.asiaPayPreparationResult);
                                        $('#asiaPayForm input[type="submit"]').click();
                                        defer.resolve(data);
                                    } else if ('multibancoTemplate' in data && data.multibancoTemplate) {
                                        // Multibanco integration
                                        removeBlockingMessage();

                                        // Create modal with Multibanco payment data
                                        const modal = newModalWithOptions({
                                            cssClass: ['multibanco-data-modal'],
                                            beforeClose: function () {
                                                return false; // Prevent modal from closing
                                            }
                                        });
                                        modal.setContent(data.multibancoTemplate);
                                        modal.open();

                                        defer.resolve(data);
                                    } else if ('portmoneData' in data && data.portmoneData) {
                                        $('body').trigger('checkout:afterHandleNextStage', { stage: members.currentStage + 2 });
                                        $('#portmoneData').val(JSON.stringify(data.portmoneData));
                                        removeBlockingMessage();
                                        $('#portmonePayment').submit();
                                    } else if ('isGooglePayPortmone' in data && data.isGooglePayPortmone) {
                                        var portmone3dsForm = $('#portmone3DS');
                                        portmone3dsForm.attr('action', data.action);
                                        portmone3dsForm.find('[name="PaReq"]').val(data.PaReq);
                                        portmone3dsForm.find('[name="MD"]').val(data.MD);
                                        portmone3dsForm.find('[name="TermUrl"]').val(data.TermUrl);
                                        portmone3dsForm.trigger('submit');
                                    } else if (data.afterpayEnabled) {
                                        $('body').trigger('checkout:afterHandleNextStage', { stage: members.currentStage + 2 });
                                        // Initalize afterpayCheckout
                                        afterpay.redirect();
                                    } else {
                                        var continueUrl = data.continueUrl;
                                        var urlParams = {};
                                        // Check if is Iyzico
                                        if ((!('isIyzico' in data) || !(data.isIyzico)) && data.orderID) {
                                            urlParams = {
                                                ID: data.orderID,
                                                token: data.orderToken
                                            };

                                            continueUrl += (continueUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(urlParams).map(function (key) {
                                                return key + '=' + encodeURIComponent(urlParams[key]);
                                            }).join('&');
                                        }
                                        window.location.href = continueUrl;
                                        defer.resolve(data);
                                    }
                                }
                            }
                        },
                        error: function (err) {
                            removeBlockingMessage();
                            if (err.responseJSON && err.responseJSON.redirectUrl) {
                                window.location.href = err.responseJSON.redirectUrl;
                            }
                        }
                    };

                    // check credit card fields with gestpay iframe
                    if (isGestPayIframeMode && $('input[name$="paymentMethod"]:checked').val() === 'CREDIT_CARD') {
                        // copy of the the fix in submitPayment prepend to avoid sending
                        // encrypt request when the order will not be created
                        var isStorePickup = $('.shipping-form input.js-shipping-method:checked').data('pickup');
                        var selectedStoreId = $('.shipping-form input#storeId').not('[value=""]').val();
                        var phoneNumber = $('input#phoneNumber').val();
                        if ((isStorePickup && !selectedStoreId) || !phoneNumber) {
                            members.gotoStage('shipping');
                            $('.error-message.invalid-data-error').show();
                            $('html, body').animate({
                                scrollTop: $('.error-message.invalid-data-error').offset().top - 75
                            }, 500, 'linear');
                            return;
                        }
                        var queryString = '';
                        if (gestpayHelper.isSavedCard()) {
                            queryString += '?savedcard=true';
                        } else if (gestpayHelper.isSavingCard()) {
                            queryString += '?savingcard=true';
                        }
                        addBlockingMessage();
                        $.ajax({
                            url: gestpayEncryptUrl + queryString,
                            method: 'GET'
                        }).done(function (data) {
                            if (data.transactionResult === 'OK') {
                                if (!gestpayHelper.isSavedCard()) {
                                    GestPay.CreatePaymentPage(data.shopLogin, data.cryptDecryptString, function (Result) {
                                        if (Result.ErrorCode == 10) {
                                            // check CVV
                                            GestPay.checkCVV(members.getSecurityCode().val(), function (Result) {
                                                members.checkGestpayResult([members.getSecurityCode().attr('name')], Result);
                                                // check CC date and email for new payment
                                                if (members.isNewPayment()) {
                                                    // check CC
                                                    GestPay.checkCC(members.getCreditCardNumber().data('cleave').getRawValue(), function (Result) {
                                                        members.checkGestpayResult([members
                                                            .getCreditCardNumber()
                                                            .attr('name')], Result);
                                                        // check exp date
                                                        GestPay.checkEXPDATE(
                                                            ('00' + members.getExpirationMonth().val()).slice(-2),
                                                            members
                                                                .getExpirationYear()
                                                                .val()
                                                                .slice(-2),
                                                            function (Result) {
                                                                members.checkGestpayResult(
                                                                    [
                                                                        members.getExpirationMonth().attr('name'),
                                                                        members.getExpirationYear().attr('name')
                                                                    ],
                                                                    Result
                                                                );
                                                                // check email
                                                                GestPay.checkEMAIL(
                                                                    members.getCreditCardFieldsEmail().val(),
                                                                    function (Result) {
                                                                        members.checkGestpayResult(
                                                                            [members.getCreditCardFieldsEmail().attr('name')],
                                                                            Result
                                                                        );
                                                                        if (
                                                                            $(
                                                                                '.payment-form *.is-invalid, .stored-payments *.is-invalid'
                                                                            ).length === 0
                                                                        ) {
                                                                            $.ajax(sendPaymentAjax);
                                                                        } else {
                                                                            removeBlockingMessage();
                                                                        }
                                                                    }
                                                                );
                                                            }
                                                        );
                                                    });
                                                } else if ($('.payment-form *.is-invalid, .stored-payments *.is-invalid').length === 0) {
                                                    $.ajax(sendPaymentAjax);
                                                } else {
                                                    removeBlockingMessage();
                                                }
                                            });
                                        } else {
                                            showPaymentErrorMessage($(plugin).data('errormsg-default'));
                                            removeBlockingMessage();
                                            defer.reject();
                                        }
                                    });
                                } else if ($('.payment-form *.is-invalid, .stored-payments *.is-invalid').length === 0) {
                                    $.ajax(sendPaymentAjax);
                                } else {
                                    removeBlockingMessage();
                                }
                            } else {
                                showPaymentErrorMessage($(plugin).data('errormsg-default'));
                                removeBlockingMessage();
                                defer.reject();
                            }
                        }).fail(function () {
                            showPaymentErrorMessage($(plugin).data('errormsg-default'));
                            removeBlockingMessage();
                            defer.reject();
                        });

                        if ($('.payment-form *.is-invalid, .stored-payments *.is-invalid').length > 0) {
                            removeBlockingMessage();
                            defer.reject();
                            return defer;
                        }
                    } else {
                        addBlockingMessage();
                        $.ajax(sendPaymentAjax);
                    }

                    return defer;
                }
                var p = $('<div>').promise(); // eslint-disable-line
                setTimeout(function () {
                    p.done(); // eslint-disable-line
                }, 500);
                return p; // eslint-disable-line
            },

            /**
             * Initialize the checkout stage.
             *
             * TODO: update this to allow stage to be set from server?
             */
            initialize: function () {
                initPostalCodeValidation();
                // set the initial state of checkout
                var currentStage = $('.data-checkout-stage').data('checkout-stage');
                members.currentStage = checkoutStages.indexOf(currentStage);
                $(plugin).attr('data-checkout-stage', checkoutStages[members.currentStage]);

                //
                // Handle Payment option selection
                //
                $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                    var methodId = $(e.target).data('methodId');
                    $('.payment-information').data('payment-method-id', methodId);
                    $('input[name$="paymentMethod"]').val(methodId);
                });

                $(document).on('change', '.consProfilePreference, .consProfilePreference1', function () {
                    if ($('.consProfilePreference').is(':checked')) {
                        $('.consPsonalizedNews, .consPsonalizedNews1').prop('disabled', false);
                        $('.js-personalized-news-container').removeClass('transparent');
                    } else {
                        $('.consPsonalizedNews, .consPsonalizedNews1').prop('disabled', true);
                        $('.consPsonalizedNews, .consPsonalizedNews1').prop('checked', false);
                        $('.js-personalized-news-container').addClass('transparent');
                    }
                });

                //
                // Handle Next State button click
                //
                $(plugin).on('click', '.next-step-button button', function (e) {
                    if ($(e.currentTarget).val() !== 'submit-shipping' && $(e.currentTarget).val() !== 'submit-payment') {
                        $('body').trigger('analytics:order_review_proceed');
                    }
                    // Check if recurrent user with billing agreement then skip payments
                    if ($(e.currentTarget).hasClass('submit-gift-option') && (plugin.data('hasBillingAgreement') === true || $(plugin).data('expressFlow') === true)) {
                        members.gotoStage('confirm-order');
                        let anchorStage = '.payment-summary';
                        let scrollTopValue = 0;
                        let anchorStageValue = $(anchorStage).offset().top;
                        let headerHeight = $('.js-mainHeader').height();
                        scrollTopValue = anchorStageValue - headerHeight;
                        $('html, body').animate({ scrollTop: scrollTopValue }, 'slow');
                        return;
                    }
                    if ($(e.currentTarget).hasClass('submit-gift-option')) {
                        localStorage.setItem('from-gift-option', true);
                    }
                    members.nextStage();
                });

                $('.submit-gift-option').on('click', function (e) {
                    if ($('.checkout-product-summary').hasClass('active')) {
                        $('.checkout-product-summary-header').trigger('click');
                    }
                });

                //
                // Handle go back arrow to previous stages
                //
                $(document).on('click', '.js-mainHeader-svgIcon_back', function (e) {
                    e.preventDefault();
                    var isKlarnaHappyFlow = !$('#checkout-main').data('klarna-unhappy');
                    var isKlarnaExpressFlow = $('#checkout-main').data('klarna-express');

                    // Redirect to cart
                    if (members.currentStage === 0 || (isKlarnaHappyFlow && isKlarnaExpressFlow)) {
                        var redirectUrl = $(e.currentTarget).data('url');
                        if (members.currentStage === 0) {
                            showCheckoutExitModal();
                        } else {
                            location.href = redirectUrl;
                        }
                        return;
                    }

                    // Cancel recurrent status
                    cancelRecurrentStatus();
                    // Manage previous stages
                    var previousStage = checkoutStages[members.currentStage - 1];
                    if (members.currentStage === 3) {
                        if ($(plugin).data('expressFlow') === true) {
                            previousStage = 'shipping';
                        } else {
                            previousStage = 'gift';
                        }
                    }
                    members.gotoStage(previousStage);
                    if (previousStage === 'shipping') {
                        $('body').trigger('checkout:addressInteration', { eventAction: 'change' });
                    } else if (previousStage === 'gift') {
                        $('body').trigger('checkout:giftInteration', { eventAction: 'change' });
                    }
                });

                $(document).on('click', '.cc-mainHeader_checkout a.no-hover', function (e) {
                    if (members.currentStage === 0) {
                        e.preventDefault();
                        showCheckoutExitModal();
                    }
                });

                $(document).on('click', '.js-login-popup', function () {
                    var modal = newModalFromSelector('login-popup', false, ['wrapperModalLogin']);
                    modal.open();
                    $(modal.modalBox).addClass('login-popup-modal');

                    Customer.accountLoginForm();
                    Customer.forgotPassword(modal);

                    $(document).on('click', '.js-close-login-popup', function () {
                        modal.close();
                        modal.destroy();
                    });
                });

                //
                // Handle Edit buttons on shipping and payment summary cards
                //
                $('.shipping-summary .edit-button', plugin).on('click', function (e) {
                    if ($('.data-checkout-stage').attr('data-express-flow') !== 'true') {
                        $('.add-to-condition-sale-list').prop('checked', false);
                    }
                    checkScalapayMultipayment();
                    cancelRecurrentStatus();
                    members.gotoStage('shipping');
                    e.preventDefault();
                });

                $('.order-items-summary .edit-button', plugin).on('click', function (e) {
                    $('body').trigger('checkout:giftInteration', { eventAction: 'change' });
                    checkScalapayMultipayment();
                    cancelRecurrentStatus();
                    members.gotoStage('gift');
                    e.preventDefault();
                    if (!$('.checkout-product-summary').hasClass('active')) {
                        $('.checkout-product-summary-header').trigger('click');
                    }
                });

                $('body').on('change', '#shippingState', function (e) {
                    if ($('.addressSelector input[type="radio"]:checked')) {
                        $('.addressSelector input[type="radio"]:checked').attr('data-state-code', $(e.currentTarget).val());
                    }
                });

                $('.payment-summary .edit-button', plugin).on('click', function (e) {
                    if ($('.credit-card-form-custom').length > 0 && $('.credit-card-form-custom.checkout-hidden').length < 1) {
                        $('.user-payment-instruments .saved-payment-instrument.selected-payment').removeClass('selected-payment');
                        $('.add-payment').addClass('checkout-hidden');
                        $('.saved-security-code .security-code-input').addClass('checkout-hidden');
                    }
                    checkScalapayMultipayment();
                    cancelRecurrentStatus();
                    members.gotoStage('payment');
                    e.preventDefault();
                });
                ExpressCheckoutHelpers.run();
                DispoHelpers.run();
                BopisHelpers.triggerShippingIfNeeded();

                $('body').on('DhlPickup:selectedPickup', (_e, d) => {
                    // Remove previous selection for pickup point
                    $('.shipping-form #pickUpPointNumber').remove();
                    $('.shipping-form #pickUpPointName').remove();
                    $('.shipping-form #pickUpPointAddress1').remove();
                    $('.shipping-form #pickUpPointCity').remove();
                    $('.shipping-form #pickUpPointPostalCode').remove();

                    // Create the elements for the current selection
                    $('.shipping-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                        d.number + '"/>');
                    $('.shipping-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="' +
                        d.name + '"/>');
                    $('.shipping-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                        d.address1 + '"/>');
                    $('.shipping-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                        d.city + '"/>');
                    $('.shipping-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                        d.postalCode + '"/>');

                    $('.pickup-point-result').hide();
                    $('.shipping-method').prop('data-pickupchosen', false);
                    $('.shipping-method-selected').prop('data-pickupchosen', true);
                    $('.next-step-button').find('.submit-shipping').prop('disabled', false);
                });

                $('body').on('InPost:selectedPickup', (_e, d) => {
                    // Remove previous selection for pickup point
                    $('.shipping-form #pickUpPointNumber').remove();
                    $('.shipping-form #pickUpPointName').remove();
                    $('.shipping-form #pickUpPointAddress1').remove();
                    $('.shipping-form #pickUpPointCity').remove();
                    $('.shipping-form #pickUpPointPostalCode').remove();

                    // Create the elements for the current selection
                    $('.shipping-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                        d.name + '"/>');
                    $('.shipping-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="InPost PUP"/>');
                    $('.shipping-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                        d.address1 + '"/>');
                    $('.shipping-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                        d.city + '"/>');
                    $('.shipping-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                        d.postalCode + '"/>');

                    $('.pickup-point-result').hide();
                    $('.shipping-method').prop('data-pickupchosen', false);
                    $('.shipping-method-selected').prop('data-pickupchosen', true);
                    $('.next-step-button').find('.submit-shipping').prop('disabled', false);
                });

                $('body').on('novaPoshta:selectedPickUpPoint', (_e, data) => {
                    // Remove previous selection for pickup point
                    $('.shipping-form #novaPoshtaWarehouseRef').remove();
                    $('.shipping-form #novaPoshtaWarehouseNameUa').remove();
                    $('.shipping-form #novaPoshtaWarehouseNameRu').remove();
                    $('.shipping-form #novaPoshtaWarehouseAddressUa').remove();
                    $('.shipping-form #novaPoshtaWarehouseAddressRu').remove();
                    $('.shipping-form #novaPoshtaWarehouseCityUa').remove();
                    $('.shipping-form #novaPoshtaWarehouseCityRu').remove();
                    $('.shipping-form #novaPoshtaWarehousePostalCode').remove();

                    // Create the elements for the current selection
                    $('.shipping-form').append('<input type="hidden" id="novaPoshtaWarehouseRef" name="novaPoshtaWarehouseRef" value="' +
                        data.ref + '"/>');
                    $('.shipping-form').append('<input type="hidden" id="novaPoshtaWarehouseNameUa" name="novaPoshtaWarehouseNameUa" value="' +
                        data.nameUa + '"/>');
                    $('.shipping-form').append('<input type="hidden" id="novaPoshtaWarehouseNameRu" name="novaPoshtaWarehouseNameRu" value="' +
                        data.nameRu + '"/>');
                    $('.shipping-form').append('<input type="hidden" id="novaPoshtaWarehouseAddressUa" name="novaPoshtaWarehouseAddressUa" value="' +
                        data.addressUa + '"/>');
                    $('.shipping-form').append('<input type="hidden" id="novaPoshtaWarehouseAddressRu" name="novaPoshtaWarehouseAddressRu" value="' +
                        data.addressRu + '"/>');

                    // City and postal code required by SOM order export
                    $('<input type="hidden" id="novaPoshtaWarehouseCityUa" name="novaPoshtaWarehouseCityUa"/>')
                        .val(data.cityUa || '').appendTo('.shipping-form');
                    $('<input type="hidden" id="novaPoshtaWarehouseCityRu" name="novaPoshtaWarehouseCityRu"/>')
                        .val(data.cityRu || '').appendTo('.shipping-form');
                    $('<input type="hidden" id="novaPoshtaWarehousePostalCode" name="novaPoshtaWarehousePostalCode"/>')
                        .val(data.postalCode || '').appendTo('.shipping-form');

                    $('.shipping-method').prop('data-pickupchosen', false);
                    $('.shipping-method-selected').prop('data-pickupchosen', true);
                    $('.next-step-button').find('.submit-shipping').prop('disabled', false);
                });

                $('.js-cards-cc').on('click', function () {
                    $('.js-cards-cc').closest('.cc-tab-container').find('#CREDIT_CARD').trigger('click');
                });

                $('.show-cc-full-image').on('mouseenter focusin', function () {
                    if (Foundation.MediaQuery.atLeast('medium')) {
                        if ($('.info-tooltip-cc').length > 0) {
                            $('.info-tooltip-cc').addClass('show');
                        }
                    }
                });
                $('.show-cc-full-image').on('mouseleave', function () {
                    if (Foundation.MediaQuery.atLeast('medium')) {
                        if ($('.info-tooltip-cc').length > 0) {
                            $('.info-tooltip-cc').removeClass('show');
                        }
                    }
                });
                // Toggle PayPal button based on the privacy consent
                $('.policy-promotion-payment').on('change', '[name^="consTrattamento_paypal"]', (e) => {
                    const $payPalButtonWrapper = $(e.currentTarget).closest('.drawer').find('.js_paypal_button_on_billing_form');

                    if ($payPalButtonWrapper.length) {
                        $payPalButtonWrapper.toggleClass('disabled', !$(e.currentTarget).is(':checked'));
                    }
                });

                $(document).on('click', '.js_paypal_button_on_billing_form', function (e) {
                    if (!$('[name^="consTrattamento_paypal"]').is(':checked')) {
                        e.preventDefault();
                        e.stopPropagation();
                        $(e.currentTarget).toggleClass('disabled', true);
                    }
                });

                // Toggle GooglePay button based on the privacy consent
                $('.policy-promotion-payment').on('change', '[name^="consTrattamento_googlePay"]', (e) => {
                    const $googlePayButtonWrapper = $(e.currentTarget).closest('.drawer').find('.js-google-pay-button-on-billing-form');

                    if ($googlePayButtonWrapper.length) {
                        $googlePayButtonWrapper.toggleClass('disabled', !$(e.currentTarget).is(':checked'));
                    }
                });

                // Toggle Klarna button based on the privacy consent
                $('.klarna-drawer .policy-promotion-payment').on('change', 'input[name^="consTrattamento_"]', function (e) {
                    const $klarnaButtonWrapper = $(e.currentTarget).closest('.drawer').find('.button-klarna-payment');
                    const isChecked = $(e.currentTarget).is(':checked');

                    if ($klarnaButtonWrapper.length) {
                        $klarnaButtonWrapper.toggleClass('disabled', !isChecked).prop('disabled', !isChecked);
                    }
                });

                $('body').on('change', '.applepay-tab-header input', function (e) {
                    formHelpers.clearPreviousErrors('.payment-form');
                    const $paymentForm = $('#dwfrm_billing');
                    var paymentForm = $paymentForm.serialize();

                    $('body').trigger('checkout:serializeBilling', {
                        form: $('#dwfrm_billing'),
                        data: paymentForm,
                        callback: function (data) {
                            paymentForm = data;
                        }
                    });
                    $.spinner().start();
                    $.ajax({
                        url: $('#dwfrm_billing').attr('action'),
                        method: 'POST',
                        data: paymentForm,
                        success: function (data) {
                            $.spinner().stop();
                            // look for field validation errors
                            if (data.error) {
                                if (data.cartError) {
                                    window.location.href = data.redirectUrl;
                                } else if ('fieldErrors' in data && data.fieldErrors.length) {
                                    data.fieldErrors.forEach(function (error) {
                                        if (Object.keys(error).length) {
                                            formHelpers.loadFormErrors('.payment-form', error);
                                        }
                                    });
                                } else if ('serverErrors' in data && data.serverErrors.length) {
                                    data.serverErrors.forEach(function (error) {
                                        showPaymentErrorMessage(error);
                                    });
                                } else if (data.errorMessage) {
                                    showPaymentErrorMessage(data.errorMessage);
                                }
                            }
                        }
                    });
                });

                $(document).on('mouseenter focusin', '.save-credit-card .info-icon', function (e) {
                    let widthLabel = $('.saveCreditCard').width();
                    let widthTooltip = $('.tooltip.add-new-card-cvv-tooltip').outerWidth();
                    let $trigger = $(this);
                    if (Foundation.MediaQuery.atLeast('large')) {
                        if (widthLabel < widthTooltip) {
                            $('.tooltip.add-new-card-cvv-tooltip').css({left: -$trigger.offset().left + $('.saveCreditCard').offset().left});
                        } else {
                            $('.tooltip.add-new-card-cvv-tooltip').css({right: -35, left: 'unset'});
                        }
                    }
                    if (!Foundation.MediaQuery.atLeast('large')) {
                        $('.tooltip.add-new-card-cvv-tooltip').css({left: -$trigger.offset().left + 10});
                    }
                    let tooltipLeft = $('.tooltip.add-new-card-cvv-tooltip').offset().left;
                    $('.tooltip-tip.save-card').css({left: $trigger.offset().left - tooltipLeft - 15});
                    $('.tooltip-tip.save-card').addClass('make-visible');
                }).on('mouseleave focusout', '.save-credit-card .info-icon', function (e) {
                    $('.tooltip-tip.save-card.make-visible').removeClass('make-visible');
                });

                Payment.handleMobileTooltip();

                //
                // remember stage (e.g. shipping)
                //
                if (!$('.js-editBillingFormCard').length) {
                    updateUrl(members.currentStage);
                }

                //
                // Listen for foward/back button press and move to correct
                // checkout-stage
                //
                $(window).on('popstate', function (e) {
                    //
                    // Back button when event state less than current state in ordered
                    // checkoutStages array.
                    //
                    if (e.state === null || checkoutStages.indexOf(e.state) < members.currentStage) {
                        if (members.currentStage === 0) {
                            updateUrl(0);

                            showCheckoutExitModal();
                        } else {
                            members.handlePrevStage(false);
                        }
                    } else if (checkoutStages.indexOf(e.state) > members.currentStage) {
                        // Forward button pressed
                        members.handleNextStage(false);
                    }
                });

                //
                // Set the form data
                //
                plugin.data('formData', formData);

                addressHelpers.checkUserSavedAddresses();
            },

            partialStage: function () {
                var stage = checkoutStages[members.currentStage];
                if (stage === 'shipping') {
                    var stepShippingCompleted = $('.shipping-form').attr('data-checkout-stage-completed');
                    if (stepShippingCompleted === 'false') {
                        $('.shipping-form').attr('data-checkout-stage-completed', 'true');
                        return true;
                    }
                }
                return false;
            },

            progressStage: function () {
                var stage = checkoutStages[members.currentStage];
                if (stage === 'payment') {
                    var offset = 0;
                    var scale = window.devicePixelRatio / 3;

                    if ($($('.policy-promotion-payment').children()[0]).children().length > 5) {
                        offset = $('.policy-promotion-payment').offset().top - (500 * scale * 1.2);
                    } else {
                        offset = $('.policy-promotion-payment').offset().top - (700 * scale);
                    }

                    // Scroll to terms and conditions
                    $('html, body').animate({
                        scrollTop: offset
                    }, 500, 'linear');

                    // Show the confirmation button
                    $('.next-step-button').removeClass('hide');
                }
            },

            /**
             * The next checkout state step updates the css for showing correct
             * buttons etc...
             */
            nextStage: function () {
                var promise = members.updateStage();

                promise.done(function () {
                    // Update UI with new stage
                    members.handleNextStage(true);
                    if (members.isPartialStage === true) {
                        members.isPartialStage = false;
                    } else {
                        $('body').trigger('checkout:afterHandleNextStage', { stage: members.currentStage + 1 });
                    }
                });

                promise.fail(function (data) {
                    // show errors
                    if (data) {
                        if (data.errorStage) {
                            members.gotoStage(data.errorStage.stage);

                            if (data.errorStage.step === 'billingAddress') {
                                var $billingAddressSameAsShipping = $('input[name$="_shippingAddressUseAsBillingAddress"]');
                                if ($billingAddressSameAsShipping.is(':checked')) {
                                    $billingAddressSameAsShipping.prop('checked', false);
                                }
                            }
                        }

                        if (data.gestpayErrorCode && $(plugin).data('errormsg-' + data.gestpayErrorCode)) {
                            $('.error-message.generic')
                                .show()
                                .find('.error-message-text')
                                .text($(plugin).data('errormsg-' + data.gestpayErrorCode));
                            $('.error-message.generic')[0].scrollIntoView();
                        } else if (data.errorMessage) {
                            $('.error-message.generic')
                                .show()
                                .find('.error-message-text')
                                .text(data.errorMessage);
                            $('.error-message.generic')[0].scrollIntoView();
                        }
                    }
                });
            },

            /**
             * The next checkout state step updates the css for showing correct
             * buttons etc...
             *
             * @param {boolean}
             *          bPushState - boolean when true pushes state using the history
             *          api.
             */
            handleNextStage: function (bPushState) {
                // Avoid proceeding to next stage from "payment" to "confirm-order" since it's an unexpected flow
                if (checkoutStages[members.currentStage] === 'payment') {
                    return;
                }

                this.progressStage();
                var partialStage = this.partialStage();
                var redirectWithShippingTriggered = $('#redirectWithShippingTriggered').val();
                if (partialStage) {
                    let item = $('.shipping-form').find('.shipping-method-block');
                    if (redirectWithShippingTriggered === 'false') {
                        $('html, body').animate({
                            scrollTop: (item.offset().top + item.height()) - 75
                        }, 500, 'linear');
                    }
                    members.isPartialStage = true;
                } else if (members.currentStage < checkoutStages.length) {
                    members.isPartialStage = false;

                    // move the last stage if it is express flow
                    if (checkoutStages[members.currentStage] === 'shipping' && $('.data-checkout-stage').attr('data-express-flow') === 'true') {
                        members.currentStage = checkoutStages.length - 1;
                    } else {
                        // move stage forward
                        members.currentStage++;
                    }

                    //
                    // show new stage in url (e.g.payment)
                    //
                    if (bPushState && members.currentStage !== checkoutStages.length) {
                        updateUrl(members.currentStage);
                        if (checkoutStages[members.currentStage]  === 'gift') {
                            $('body').trigger('address:submitFromCheckout', { checkoutStep: 'funnel_step4' });
                        }
                        if (checkoutStages[members.currentStage]  === 'payment') {
                            $('body').trigger('address:submitFromCheckout', { checkoutStep: 'funnel_step3' });
                        }
                    }
                }

                // Set the next stage on the DOM
                $(plugin).attr('data-checkout-stage', checkoutStages[members.currentStage]);

                // Scroll to anchored element on stage update otherwise scroll to top
                const stage = checkoutStages[members.currentStage];
                if (stage === 'gift' || stage === 'payment') {
                    let anchorStage = {
                        'payment': '.payment-form'
                    };

                    let scrollTopValue = 0;
                    if (anchorStage[stage]) {
                        let anchorStageValue = $(anchorStage[stage]).offset().top;
                        let headerHeight = $('.js-mainHeader').height();
                        scrollTopValue = anchorStageValue - headerHeight;
                    }
                    $('html, body').animate({ scrollTop: scrollTopValue }, 'slow');
                }
            },

            /**
             * Previous State
             */
            handlePrevStage: function () {
                if (members.currentStage > 0) {
                    // move state back
                    members.currentStage--;
                    updateUrl(members.currentStage);
                }

                $(plugin).attr('data-checkout-stage', checkoutStages[members.currentStage]);
            },

            /**
             * Use window history to go to a checkout stage
             *
             * @param {string}
             *          stageName - the checkout state to goto
             */
            gotoStage: function (stageName) {
                members.currentStage = checkoutStages.indexOf(stageName);
                updateUrl(members.currentStage);
                $(plugin).attr('data-checkout-stage', checkoutStages[members.currentStage]);
            },
            checkGestpayResult: function (fields, Result, _formContainer) {
                if (Result.ErrorCode != 0) {
                    $.spinner().stop();
                    var error = {};
                    $.each(fields, function (fieldIndex) {
                        error[fields[fieldIndex]] = $(plugin).data('errormsg-' + Result.ErrorCode) || $(plugin).data('errormsgDefault') || Result.ErrorDescription;
                    });
                    formHelpers.loadFormErrors($('.payment-information').data('is-new-payment') ? '.payment-form' : '.stored-payments', error, true);
                    $('.error-message.generic')
                        .show()
                        .find('.error-message-text')
                        .text($(plugin).data('errormsg-' + Result.ErrorCode) || $(plugin).data('errormsgDefault'));

                    // $('.error-message.generic')[0].scrollIntoView();
                    scrollToTargetConsideringHeader($('.error-message.generic')[0]);
                }
            },
            getCreditCardNumber: function () {
                let baseSelector = '[data-method-id="CREDIT_CARD"]';
                if ($('#CREDIT_CARD_AMEX:checked').length > 0) {
                    baseSelector = '[data-method-id="CREDIT_CARD_AMEX"]';
                }
                return $(baseSelector + ' input[name$=cardNumber]');
            },
            getSecurityCode: function () {
                let baseSelector = '[data-method-id="CREDIT_CARD"]';
                if ($('#CREDIT_CARD_AMEX:checked').length > 0) {
                    baseSelector = '[data-method-id="CREDIT_CARD_AMEX"]';
                }
                return ($('.payment-information').data('is-new-payment') ?
                    $(baseSelector + ' input[name$="_securityCode"]') :
                    $(baseSelector + ' input[name$="saved-payment-security-code"]'));
            },
            getExpirationMonth: function () {
                let baseSelector = '[data-method-id="CREDIT_CARD"]';
                if ($('#CREDIT_CARD_AMEX:checked').length > 0) {
                    baseSelector = '[data-method-id="CREDIT_CARD_AMEX"]';
                }
                return $(baseSelector + ' select[name$="_expirationMonth"]');
            },
            getExpirationYear: function () {
                let baseSelector = '[data-method-id="CREDIT_CARD"]';
                if ($('#CREDIT_CARD_AMEX:checked').length > 0) {
                    baseSelector = '[data-method-id="CREDIT_CARD_AMEX"]';
                }
                return $(baseSelector + ' select[name$="_expirationYear"]');
            },
            getCreditCardFieldsEmail: function () {
                let baseSelector = '[data-method-id="CREDIT_CARD"]';
                if ($('#CREDIT_CARD_AMEX:checked').length > 0) {
                    baseSelector = '[data-method-id="CREDIT_CARD_AMEX"]';
                }
                return $(baseSelector + ' input[name$="_creditCardFields_email"]');
            },
            isNewPayment: function () {
                return $('.payment-information').data('is-new-payment');
            }
        };

        //
        // Initialize the checkout
        //
        members.initialize();

        //
        // Add and remove event listener on click for the autocomplete functionality in the credit card form's month field
        //
        function monthDropDownMenuIsSelected () {
            return $('#expirationMonth_chosen').hasClass('chosen-with-drop');
        }
        let monthInput = '';
        let autocompleteMonth = (e) => {
            let keyValue = e.key;
            if (Number(keyValue) >= 0 || Number(keyValue) <= 9) {
                monthInput += keyValue;
            }
            switch (monthInput) {
            case '0':
                break;
            case '1':
                break;
            case '01':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='1']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '02':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='2']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '03':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='3']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '04':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='4']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '05':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='5']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '06':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='6']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '07':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='7']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '08':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='8']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '09':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='9']").mouseup();
                }
                monthInput = '';
                break;
            case '10':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='10']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '11':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='11']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '12':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='12']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '2':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='2']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '3':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='3']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '4':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='4']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '5':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='5']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '6':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='6']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '7':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='7']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '8':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='8']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            case '9':
                $(document).off('keypress', autocompleteMonth);
                if (monthDropDownMenuIsSelected()) {
                    $("#expirationMonth_chosen .chosen-drop .chosen-results li[data-option-array-index='9']").mouseup();
                }
                $(document).click();
                monthInput = '';
                break;
            default:
                monthInput = '';
            }
        };
        $('#expirationMonth_chosen').click(() => {
            monthInput = '';
            $(document).off('keypress', autocompleteMonth);
            $(document).on('keypress', autocompleteMonth);
        });

        return this;
    };
}(jQuery));

var exports = {
    initialize: function () {
        $('#checkout-main').checkout();
        $('.pointsLinkToBeRendered').html($('#formattedPointsLink').text());
        checkoutLongDistanceTooltip();
    },
    sortSelectedShippingMethod: function () {
        // Move selected shipping method in first position of the aggregator (index 0 is taken by the header)
        if ($('.shipping-method-selected').index() !== 1) {
            const $selectedShippingGroup = $('.shipping-type-aggregator.selected-group');
            const $headerContainer = $selectedShippingGroup.find('.shipping-type-aggregator_title').length ? $selectedShippingGroup.find('.shipping-type-aggregator_title') : $selectedShippingGroup.find('.shipping-type-header'); 
            $('.shipping-method-selected').insertAfter($headerContainer);
        }
        $('.shipping-method-selected').removeClass('shipping-method-first');
    },
    updateCheckoutView: function () {
        $('body').on('checkout:updateCheckoutView', function (_e, data) {
            if (Foundation.MediaQuery.atLeast('medium')) {
                $('.orderProductMobile').remove();
            }
            if (!Foundation.MediaQuery.atLeast('medium')) {
                $('.orderProductDesktop').remove();
            }
            shippingHelpers.methods.updateMultiShipInformation(data.order);
            summaryHelpers.updateTotals(data.order.totals);
            if (data.order.totals && data.order.totals.totalPoints && $('.data-checkout-stage').attr('data-customer-type') === 'registered') {
                $('.estimated-points-logged').html(data.order.totals.totalPoints);
            }
            // if we are returning from paypal the shipping method is not editable
            var isReturnFromPayPal = $('input[name=dwfrm_shipping_shippingAddress_shippingMethodID]:checked').prop('disabled');

            if (isReturnFromPayPal) {
                var shipping = data.order.shipping[0];
                var shippingMethodId = $('input[name=dwfrm_shipping_shippingAddress_shippingMethodID]:checked').attr('value');
                var found = false;
                for (var i = 0; i < shipping.applicableShippingMethods.length && !found; i++) {
                    if (shipping.applicableShippingMethods[i].ID === shippingMethodId) {
                        found = true;
                        data.order.shipping[0].selectedShippingMethod = shipping.applicableShippingMethods[i];
                    }
                }
            }
            data.order.shipping.forEach(function (shipping) {
                shipping.isBopis = data.urlParams ? data.urlParams.isBopis : (data.isBopis || $('#isBopis').val() === 'true' || false);
                shippingHelpers.methods.updateShippingInformation(shipping, data.order, data.customer, data.options, data.address);
            });
            addressHelpers.checkUserSavedAddresses();
            billingHelpers.methods.updateBillingInformation(data.order, data.customer, data.options, data.action);
            billingHelpers.methods.updatePaymentInformation(data.order, data.options, data.action);
            summaryHelpers.updateOrderProductSummaryInformation(data.order, data.options);

            // For Multipayments: Check if there are a giftcard + another method to hide the info banner
            var thereIsGiftcard = false;
            var thereIsAnOtherPayment = false;
            if (data.order.billing.payment && data.order.billing.payment.selectedPaymentInstruments &&
                data.order.billing.payment.selectedPaymentInstruments.length > 0) {
                for (let i = 0; i < data.order.billing.payment.selectedPaymentInstruments.length; i++) {
                    var currentPaymentInstrument = data.order.billing.payment.selectedPaymentInstruments[i];
                    if (currentPaymentInstrument.paymentMethod === 'GIFT_CARD' || currentPaymentInstrument.paymentMethod === 'RESO_CARD') {
                        thereIsGiftcard = true;
                    } else {
                        thereIsAnOtherPayment = true;
                    }
                }
            }

            if (!thereIsGiftcard) {
                $('.item-giftcard').addClass('hidden');
                $('.giftcard-amount-feedback').addClass('hidden');
                $('.giftCardRemainedAmount').addClass('hidden').text('');
                $('.giftcard-applied').addClass('hidden').text('');
                $('.giftcard-total').text('');
                $('#giftCardNumber').val('');
                $('#giftCardPin').val('');
                $('.giftcard-applied').removeClass('multipaymentToSelect');
                $('#giftCardFormGroup .buttonRemoveGiftcard').addClass('hide');
                $('#giftCardFormGroup .js-controlCardButtons').removeClass('hide');
                $('#giftCardFormGroup .js-recaptcha').removeClass('hide');
                $('.giftCardNumberField, .giftCardPinField').removeClass('giftcardSubmitted');
            }

            $('body').trigger('scalaPay:updateScalaPayPaymentMethod', data.order);
        });
    },
    checkoutLongDistanceTooltip: checkoutLongDistanceTooltip,

};

[billingHelpers, addressHelpers].forEach(function (library) {
    Object.keys(library).forEach(function (item) {
        exports[item] = library[item];
    });
});

const afterpay = {
    redirect: function () {
        $('.alert.error-message p.error-message-text').remove();
        var csrfToken = $('input[name="csrf_token"]').val();
        var isAfterpayUrl = $('input[name="dwfrm_afterpay_isAfterpayUrl"]').val();

        $.ajax({
            url: isAfterpayUrl + '?csrf_token=' + csrfToken,
            type: 'post',
            success: function (data) {
                if (typeof (data && data.isAfterpay) !== 'undefined' && data.isAfterpay) {
                    // payment method is afterpay
                    $('button.submit-payment').text(data.resource.pleaseWait);
                    var redirectMessage = data.resource.redirectMessage;
                    var redirectAfterpayUrl = $('input[name="dwfrm_afterpay_redirectAfterpayUrl"]').val();
                    // get redirect url
                    $.ajax({
                        url: redirectAfterpayUrl + '?csrf_token=' + csrfToken,
                        type: 'post',
                        success: function (redirectData) {
                            var defer = new $.Deferred();
                            $('.alert.error-message').html('<p class="error-message-text"></p>');
                            $('.alert.error-message p.error-message-text').text(redirectMessage);
                            if (redirectData.error) {
                                if (redirectData.cartError) {
                                    window.location.href = redirectData.cartUrl;
                                    defer.reject();
                                } else {
                                    // go to appropriate stage and display error message
                                    defer.reject(redirectData);
                                }
                            } else {
                                var urlParams;
                                var redirectUrl = redirectData.redirectUrl;
                                if (redirectData.redirectTokenResponse.apToken) {
                                    urlParams = {
                                        afterpayToken: encodeURIComponent(redirectData.redirectTokenResponse.apToken),
                                        countryCode: redirectData.countryCode
                                    };
                                } else {
                                    urlParams = {
                                        errorMessage: redirectData.redirectTokenResponse.errorMessage.message,
                                        errorCode: redirectData.redirectTokenResponse.errorMessage.httpStatusCode
                                    };
                                }
                                redirectUrl += (redirectUrl.indexOf('?') !== -1 ? '&' : '?') +
                                Object.keys(urlParams).map(function (key) {
                                    return key + '=' + encodeURIComponent(urlParams[key]);
                                }).join('&');
                                window.location.href = redirectUrl;
                                defer.reject();
                            }
                        }
                    });
                }
            }
        });
    }
};

module.exports = exports;
